var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "vueUploadModal",
    staticClass: "new-file-upload",
    attrs: {
      "modal-name": "uploadModal",
      "show-close-icon": false,
      "click-to-close": false,
      "showHeaderAria": true,
      "overrideFocusValue": false
    }
  }, [_c('h2', {
    staticClass: "text-center new-file-upload-header",
    attrs: {
      "id": "customs-vmodal-header-title"
    }
  }, [_vm._v(_vm._s(_vm.translations.uploadModalHeader))]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('base-spinner', {
    attrs: {
      "size": "50",
      "position": "static"
    }
  })], 1), _c('h5', {
    staticClass: "text-center new-file-upload-subheader header--no-text-transform"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.uploadModalSubHeader1) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.translations.uploadModalSubHeader2) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }